import { OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Data } from '../../helpers';
import { DashboardService } from '../../dashboard';
import { Subscription } from 'rxjs/Rx';
import { ErrorHandlerService } from '../../services';
import { ConfirmationService } from 'primeng/primeng';
import { PaymentHelper } from '../commons/helper/payment';
import { LoginService } from "../../login";
var SponsorComponent = /** @class */ (function () {
    function SponsorComponent(data, dashboardService, errorHandlerService, confirmationService, loginService, paymentHelper, router, route) {
        this.data = data;
        this.dashboardService = dashboardService;
        this.errorHandlerService = errorHandlerService;
        this.confirmationService = confirmationService;
        this.loginService = loginService;
        this.paymentHelper = paymentHelper;
        this.router = router;
        this.route = route;
        this.subscriptions = [];
        this.showSpinner = false;
        this.showOnlyOverlay = false;
        this.showErrorMessageTitle = "";
        this.showErrorMessages = [];
        this.isValidationError = false;
        this.showErrorPopupWidthInPercentage = "100%";
        this.showErrorModalDialog = false;
        this.isSignUp = true;
        this.pleaseWait = true;
        this.payPalId = "";
        this.sponsorPay = {};
        this.msgTitle = "";
        this.msgContent = "";
        this.acceptTC = false;
        this.popUp = false;
        this.loading = false;
        this.countryArr = {};
        this.proceedSponsor = {
            sponsorshipLevel: "Silver",
            benefits: "",
            amount: 0
        };
        this.sponsorshipLevels = [
            {
                sponsorshipLevel: "Silver",
                benefits: "",
                amount: 0
            },
            {
                sponsorshipLevel: "Gold",
                benefits: "",
                amount: 0
            },
            {
                sponsorshipLevel: "Platinum",
                benefits: "",
                amount: 0
            }
        ];
        this.selectedValues = [];
        this.selectedStep = "one";
        this.selectedLevel = "";
        this.previewurl = "";
        this.formData = null;
        this.logoURL = "";
        this.companyNameErr = false;
        this.companyWebsiteErr = false;
        this.invalidURL = false;
        this.validationReq = {
            tcReq: false,
            firstNameReq: false,
            lastNameReq: false,
            streetReq: false,
            cityReq: false,
            zipReq: false,
            countryReq: false,
            stateReq: false
        };
    }
    SponsorComponent.prototype.editDisplay = function (edit) {
        if (edit) {
            return "block";
        }
        else {
            return "none";
        }
    };
    SponsorComponent.prototype.proceedNow = function (price, content, type) {
    };
    SponsorComponent.prototype.selectedSponsor = function (e, val) {
        if (e) {
            this.selectedValues = [];
            this.selectedValues.push(val);
            this.selectedLevel = val;
        }
    };
    SponsorComponent.prototype.ngOnInit = function () {
        this.showSpinner = true;
        this.initFn();
    };
    SponsorComponent.prototype.initFn = function () {
        var _this = this;
        this.route.queryParams.subscribe(function (params) {
            _this.query = params['courseId'] || 0;
            console.log('The CourseId in ViewCourse ==>' + _this.query);
            if (_this.query != '0') {
                _this.loginService.getCourse(_this.query).subscribe(function (data) {
                    _this.sponsorshipLevels = data.sponsorshipLevels;
                }, function (error) { });
            }
        });
        this.countryArr = this.paymentHelper.paypalCountries();
        //call the loginService
        var s1 = this.dashboardService.userSummary1().subscribe(function (data) {
            //console.log('usersummary', data);
            _this.sponsorPay.firstName = data.firstName;
            _this.sponsorPay.lastName = data.lastName;
            _this.showSpinner = false;
        }, function (error) { console.log(error); });
        this.subscriptions.push(s1);
        var s2 = this.loginService.userCountry().subscribe(function (result) {
            var country_name = result.country_name;
            console.log("user country " + country_name);
            for (var i = 0, len = _this.countryArr.length; i < len; i++) {
                var country = _this.countryArr[i];
                //check name and user country name
                if (country.name.toUpperCase() === country_name.toUpperCase()) {
                    _this.sponsorPay.country = country.code;
                    console.log("Loop is going to break. for " + country_name);
                    break;
                }
            }
        }, function (error) {
            console.log("user country retrieval service failed!!! with " + error);
        });
        this.subscriptions.push(s2);
    };
    SponsorComponent.prototype.proceedNext = function (sponsor) {
        this.proceedSponsor = sponsor;
        this.selectedStep = 'two';
    };
    SponsorComponent.prototype.sponsorLogoUpload = function (event) {
        var _this = this;
        this.formData = null;
        this.formData = new FormData();
        var date = new Date();
        var fileList = event.target.files;
        if (fileList.length > 0) {
            var file = fileList[0];
            this.formData.append('file', file, file.name);
        }
        if (event.target.files && event.target.files[0]) {
            var reader = new FileReader();
            //this.previewurl = reader.result;
            reader.onload = function (event) {
                _this.previewurl = event.target['result'];
            };
            reader.readAsDataURL(event.target.files[0]);
        }
    };
    SponsorComponent.prototype.checkURL = function () {
        this.invalidURL = true;
        if (this.companyName == "" || this.companyName == null) {
            this.companyNameErr = true;
        }
    };
    SponsorComponent.prototype.proceedToPay = function () {
        var _this = this;
        if (this.companyName == "" || this.companyName == null) {
            this.companyNameErr = true;
            return;
        }
        if (this.companyWebsite == "" || this.companyWebsite == null) {
            this.companyWebsiteErr = true;
            return;
        }
        this.showSpinner = true;
        if (!(this.formData == null)) {
            var s1 = this.dashboardService.courseImageUpload(this.formData).subscribe(function (data) {
                _this.showSpinner = false;
                _this.logoURL = data;
                _this.formData = null;
                _this.selectedStep = 'two-three';
            }, function (error) {
                _this.showSpinner = false;
                _this.formData = null;
                _this.handleError("There was an error uploading the Logo.");
            });
            this.subscriptions.push(s1);
        }
        else {
            this.showSpinner = false;
            this.selectedStep = 'two-three';
        }
        this.sponsorPay.company = this.companyName;
    };
    SponsorComponent.prototype.creditCardAction = function () {
        var _this = this;
        if (this.acceptTC == false) {
            this.msgTitle = "Validation Error!!";
            this.msgContent = "Please accept the Terms & Conditions";
            this.popUp = true;
            return;
        }
        this.loading = true;
        this.sponsorPay.paypalId = this.payPalId.toString();
        this.sponsorPay.type = this.getCreditCardType(this.sponsorPay.cardNumber);
        var url = location.href;
        this.sponsorPay.cancelUrl = url.replace("upgradeplan", "upgrade?payment=cancel");
        this.sponsorPay.returnUrl = url.replace("upgradeplan", "upgrade?payment=success");
        console.log(this.sponsorPay);
        this.dashboardService.upgradePlanCC(this.sponsorPay).subscribe(function (data) {
            console.log(data);
            _this.loading = false;
            if (data.success == false) {
                _this.msgTitle = "Error!!";
                _this.msgContent = data.error;
                _this.popUp = true;
            }
        }, function (error) {
            if (error.Uvsity_Errors) {
                _this.msgTitle = "Error";
                _this.msgContent = error.Uvsity_Errors;
                _this.popUp = true;
            }
            _this.loading = false;
        });
    };
    SponsorComponent.prototype.checkNullOrEmpty = function (field) {
        if (field == null || field == "")
            return true;
        else
            return false;
    };
    SponsorComponent.prototype.payPalAction = function () {
        var _this = this;
        var errMsg = "";
        if (this.checkNullOrEmpty(this.sponsorPay.firstName)) {
            errMsg += "<li>First name is required.</li>";
            this.validationReq.firstNameReq = true;
        }
        if (this.checkNullOrEmpty(this.sponsorPay.lastName)) {
            errMsg += "<li>Last name is required.</li>";
            this.validationReq.lastNameReq = true;
        }
        if (this.checkNullOrEmpty(this.sponsorPay.street)) {
            errMsg += "<li>Street is required.</li>";
            this.validationReq.streetReq = true;
        }
        if (this.checkNullOrEmpty(this.sponsorPay.city)) {
            errMsg += "<li>City is required.</li>";
            this.validationReq.cityReq = true;
        }
        if (this.checkNullOrEmpty(this.sponsorPay.zip)) {
            errMsg += "<li>Zip is required.</li>";
            this.validationReq.zipReq = true;
        }
        if (this.checkNullOrEmpty(this.sponsorPay.country)) {
            errMsg += "<li>Country is required.</li>";
            this.validationReq.countryReq = true;
        }
        if (this.checkNullOrEmpty(this.sponsorPay.state)) {
            errMsg += "<li>State is required.</li>";
            this.validationReq.stateReq = true;
        }
        if (errMsg != "") {
            // this.msgTitle = "Validation Error!!";
            // this.msgContent = errMsg;
            // this.popUp = true;
            return;
        }
        this.showOnlyOverlay = true;
        this.showErrorMessageTitle = 'Info!!';
        this.showErrorMessages.push("Please wait... Processing payment...");
        this.isValidationError = false;
        this.showErrorPopupWidthInPercentage = "100%";
        this.showErrorModalDialog = true;
        this.isSignUp = true;
        this.pleaseWait = true;
        this.loading = true;
        // this.msgTitle = "Please Wait!!";
        // this.msgContent = "Processing Payment...";
        // this.popUp = true;
        var url = location.href;
        var redirect_url = process.env.HOST_URL + "?accessPage=dashboard/sponsorThankyou/" + this.query;
        var query = "?id=" + this.query + "&typeId=" + this.proceedSponsor.sponsorshipLevelId + "&sponsor=true&country=" + this.sponsorPay.country + "&return_url=" + redirect_url + "&logoUrl=" + this.logoURL + "&companyName=" + this.companyName + "&companyWebsite=" + this.companyWebsite;
        this.dashboardService.registerPaypal(query).subscribe(function (data) {
            console.log(data);
            if (data.status == 'REDIRECT') {
                _this.closeErrorPopup();
                window.location.href = data.approval_url;
                _this.loading = false;
            }
            else {
                _this.closeErrorPopup();
                _this.msgTitle = "Error!!";
                _this.msgContent = data.errorMsg;
                _this.popUp = true;
            }
        }, function (error) {
            if (error.Uvsity_Errors) {
                _this.msgTitle = "Error";
                _this.msgContent = error.Uvsity_Errors;
                _this.popUp = true;
            }
            _this.loading = false;
        });
    };
    SponsorComponent.prototype.closeErrorPopup = function () {
        this.showOnlyOverlay = false;
        this.showErrorMessageTitle = 'Info!!';
        this.showErrorMessages.push("Please wait... Authenticating...");
        this.isValidationError = false;
        this.showErrorPopupWidthInPercentage = "100%";
        this.showErrorModalDialog = false;
        this.isSignUp = false;
        this.pleaseWait = false;
    };
    SponsorComponent.prototype.isUrl = function (word) {
        var validFirstBits = ["ftp://", "http://", "https://", "www."];
        if (word != undefined && word.length > 0) {
            var n = word.charAt(0);
            var strStartsWithALetter = (n >= 'A' && n <= 'Z') || (n >= 'a' && n <= 'z') || (n >= 0 && n <= 9);
            if (!strStartsWithALetter)
                return false;
            validFirstBits.push(n);
        }
        var invalidPatterns = [" ", "//.", ".."];
        // less than www.1.dk
        if (!word || word.length < 8)
            return false;
        // Let's check and see, if our candidate starts with some of our valid first bits
        var firstBitIsValid = validFirstBits.some(function (bit) { return word.indexOf(bit) === 0; });
        if (!firstBitIsValid)
            return false;
        var hasInvalidPatterns = invalidPatterns.some(function (pattern) { return word.indexOf(pattern) !== -1; });
        if (hasInvalidPatterns)
            return false;
        var dotSplit = word.split(".");
        if (dotSplit.length > 1) {
            var lastBit = dotSplit.pop(); // string or undefined
            if (!lastBit)
                return false;
            var length_1 = lastBit.length;
            var lastBitIsValid = length_1 > 1 || (length_1 === 1 && !isNaN(parseInt(lastBit)));
            return !!lastBitIsValid;
        }
        return false;
    };
    SponsorComponent.prototype.getCreditCardType = function (number) {
        //start without knowing the credit card type
        var re = new RegExp("^4");
        if (number.match(re) != null)
            return "visa";
        // Mastercard
        // Updated for Mastercard 2017 BINs expansion
        if (/^(5[1-5][0-9]{14}|2(22[1-9][0-9]{12}|2[3-9][0-9]{13}|[3-6][0-9]{14}|7[0-1][0-9]{13}|720[0-9]{12}))$/.test(number))
            return "mastercard";
        // AMEX
        re = new RegExp("^3[47]");
        if (number.match(re) != null)
            return "amex";
        // Discover
        re = new RegExp("^(6011|622(12[6-9]|1[3-9][0-9]|[2-8][0-9]{2}|9[0-1][0-9]|92[0-5]|64[4-9])|65)");
        if (number.match(re) != null)
            return "discover";
        // Diners
        re = new RegExp("^36");
        if (number.match(re) != null)
            return "diners";
        // Diners - Carte Blanche
        re = new RegExp("^30[0-5]");
        if (number.match(re) != null)
            return "diners";
        // JCB
        re = new RegExp("^35(2[89]|[3-8][0-9])");
        if (number.match(re) != null)
            return "jcb";
        // Visa Electron
        re = new RegExp("^(4026|417500|4508|4844|491(3|7))");
        if (number.match(re) != null)
            return "visa";
        return "";
    };
    SponsorComponent.prototype.validateCardNumber = function () {
        if (this.sponsorPay.cardNumber === undefined ||
            this.sponsorPay.cardNumber === "") {
            console.log("no need to validate an empty creditcard");
            return;
        }
        if (!this.paymentHelper.isValid(this.sponsorPay.cardNumber)) {
            this.loading = false;
            this.msgTitle = "Error!!";
            this.msgContent = "Invalid Creditcard Number, please check the number";
            this.popUp = true;
        }
        else {
            this.sponsorPay.type = this.getCreditCardType(this.sponsorPay.cardNumber);
            if (this.sponsorPay.type == "") {
                this.loading = false;
                this.msgTitle = "Error!!";
                this.msgContent = "Invalid Creditcard Number, please check the number";
                this.popUp = true;
            }
        }
    };
    SponsorComponent.prototype.handleError = function (error) {
        //console.log("The error inside the Error Handler==>" + error);
        var url = error.url;
        //console.log("The URL of the error==>"+error.url);
        if (url == undefined) {
            return;
        }
        //console.log("Throwing the error now. Shall call the errorHandlerService throwError method");
        this.errorHandlerService.throwError(error);
    };
    SponsorComponent.prototype.ngOnDestroy = function () {
        this.subscriptions.forEach(function (element) {
            element.unsubscribe();
        });
    };
    return SponsorComponent;
}());
export { SponsorComponent };
//# sourceMappingURL=sponsor.component.js.map